/*
  Code taken from RMS website (regions.aws.dev) and modified
  https://code.amazon.com/packages/RegionServicesReactLibrary/blobs/mainline_4.3/--/src/components/RegionsWebsiteAppLayout/Header/DarkModeToggle.tsx
 */

import React, { useEffect, useState } from 'react';
import { Icon, Toggle } from '@amzn/awsui-components-react-v3';

const LOCAL_STORAGE_KEY = 'omniDarkModeEnabled';
const ENABLED = 'enabled';
const DISABLED = 'disabled';
const DARK_MODE_CLASS_NAME = 'awsui-polaris-dark-mode';

/**
 * Retrieves the theme mode from local storage
 */
export const getDarkModeSetting = (): boolean => {
  let setting: string;
  try {
    setting = localStorage.getItem(LOCAL_STORAGE_KEY);
  } catch (err) {
    console.warn(`Failed to read from local storage: ${err?.message}`);
  }
  return setting === 'enabled';
};

/**
 * Applies the theme mode and saves it to local storage
 */
export const setDarkModeSetting = (setting: boolean) => {
  applyDarkMode(setting);
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, setting ? ENABLED : DISABLED);
  } catch (err) {
    console.warn(`Failed to write to local storage: ${err?.message}`);
  }
};

export const applyDarkMode = (darkMode: boolean) => {
  if (darkMode) {
    document.body.classList.add(DARK_MODE_CLASS_NAME);
  } else {
    document.body.classList.remove(DARK_MODE_CLASS_NAME);
  }
};

/**
 * A toggle button that applies light or dark mode globally
 */
export const DarkModeToggle = () => {
  const [darkMode, setDarkMode] = useState(getDarkModeSetting());

  useEffect(() => {
    setDarkModeSetting(darkMode);
  }, [darkMode]);

  return (
    <div style={{ marginLeft: '-20px' }}>
      <Toggle
        checked={darkMode}
        ariaLabel='Toggle dark mode'
        onChange={(e) => {
          setDarkMode(e.detail.checked);
          setDarkModeSetting(e.detail.checked);
        }}
      >
        <Icon
          svg={
            <svg
              style={{ zIndex: 99 }}
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M12.8166 9.79921C12.8417 9.75608 12.7942 9.70771 12.7497 9.73041C11.9008 10.164 10.9392 10.4085 9.92054 10.4085C6.48046 10.4085 3.69172 7.61979 3.69172 4.17971C3.69172 3.16099 3.93628 2.19938 4.36989 1.3504C4.39259 1.30596 4.34423 1.25842 4.3011 1.28351C2.44675 2.36242 1.2002 4.37123 1.2002 6.67119C1.2002 10.1113 3.98893 12.9 7.42901 12.9C9.72893 12.9 11.7377 11.6535 12.8166 9.79921Z'
                fill='white'
                stroke='white'
                strokeWidth='2'
                className='filled'
              />
            </svg>
          }
        />
      </Toggle>
    </div>
  );
};
